const PROPERTY = {
    GENERAL: 'PropertyGeneral',
    RELATIONS: 'PropertyRelations',
    ADMINISTRATION: 'PropertyAdministration',
    CONSTRUCTION: 'PropertyConstruction',
    FINANC: 'PropertyFinanc',
    INVOICE: 'PropertyInvoice',
    MIJNVERHUIS: 'PropertyMijnverhuis',
    SMOOVED: 'PropertySmooved',
    KEURING_PLATFORM: 'PropertyKeuringPlatform',
    PROSPECTION: 'PropertyProspection',
    KORFINE: 'PropertyKorfine'
};

const PROJECT = {
    GENERAL: 'ProjectGeneral',
    ADMINISTRATION: 'ProjectAdministration',
    CONSTRUCTION: 'ProjectConstruction',
};

const DEMAND = {
    GENERAL: 'DemandGeneral'
};

const PERSON = {
    GENERAL: 'PersonGeneral',
    DETAIL: 'PersonDetail',
    RELATION: 'PersonRelation'
};

const TASK = {
    GENERAL: 'TaskGeneral'
};

const COMPANY = {
    GENERAL: 'CompanyGeneral'
}

const REPORT = {
    LARGE_MAILING: 'ReportLargeMailing'
}

const MODULE_NAME = {
    Property: "Property",
    Project: "Project",
    Demand: "Demand",
    Person: "Person",
    Task: "Task",
    Company: "Company",
    Report: "Report"
};

const USER = {
    UserListing: "UserListing"
}

export const VALIDATION_SCOPE = {
    PROPERTY,
    PROJECT,
    DEMAND,
    PERSON,
    TASK,
    COMPANY,
    REPORT,
    MODULE_NAME,
    USER
};

